import { render } from "./LinkDetailImage.vue?vue&type=template&id=65bacc8a"
import script from "./LinkDetailImage.vue?vue&type=script&lang=js"
export * from "./LinkDetailImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__